import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import AuthReducer from "./reducers/AuthReducer";
import contactReducer from "./reducers/contactReducer";
import { PostPinReducer, GetPinReducer } from "./reducers/PinReducer";
import {PostReducer, FetchPostsReducer, FetchAllPostsReducer,FetchDetailsReducer, FetchPostByIdReducer, UpdatePostReducer, UpdatePostImageReducer} from './reducers/PostReducer';
import { updateNameReducer } from "./reducers/ProfileReducer";
import { composeWithDevTools } from "redux-devtools-extension";

const rootReducers = combineReducers({
    AuthReducer,
    PostReducer,
    FetchDetailsReducer,
    FetchPostsReducer,
    FetchAllPostsReducer,
    FetchPostByIdReducer,
    UpdatePostReducer,
    UpdatePostImageReducer,
    updateNameReducer,
    PostPinReducer,
    GetPinReducer,
    contactReducer
});

const middlewares = [ thunkMiddleware ];
const Store = createStore(rootReducers, composeWithDevTools(applyMiddleware(...middlewares)));

export default Store;